<template>
  <div>
    <div class="rfa-container">
      <div>
        <div class="summary white-box">
          <h2>Suivi des RFA</h2>
          <div class="chart">
            <canvas id="rfa-chart" width="280" height="280"></canvas>
            <span v-if="rfaDatas.length > 0" class="total">{{rfaDatas.length}}</span>
          </div>
          <div class="d-flex align-items-center">
            <span class="rfa-status-circle-1 inline"></span>
            {{rfaDatas.filter(row => row.RfaPaymentStatus == 1).length}}
             à faire
          </div>
          <div class="d-flex align-items-center">
            <span class="rfa-status-circle-2 inline"></span>
            {{rfaDatas.filter(row => row.RfaPaymentStatus == 2).length}}
             facturés
          </div>
          <div class="d-flex align-items-center">
            <span class="rfa-status-circle-3 inline"></span>
            {{rfaDatas.filter(row => row.RfaPaymentStatus == 3).length}}
             payés
          </div>
          <div class="d-flex align-items-center">
            <span class="rfa-status-circle-4 inline"></span>
            {{rfaDatas.filter(row => row.RfaPaymentStatus == 4).length}}
             versés
          </div>
        </div>
      </div>
      <div class="details white-box">
        <h2>Détail des RFA</h2>
        <div class="legend">
          <div :class="{active: activeLegend[0]}" @click="toggleActiveLegend(0)">A faire</div>
          <div :class="{active: activeLegend[1]}" @click="toggleActiveLegend(1)">Facturés</div>
          <div :class="{active: activeLegend[2]}" @click="toggleActiveLegend(2)">Payés</div>
          <div :class="{active: activeLegend[3]}" @click="toggleActiveLegend(3)">Versés</div>
        </div>
        <vue-good-table class="card-table"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                                        enabled: true,
                                        rowsPerPageLabel: 'Lignes par page',
                                        ofLabel: 'sur',
                                        nextLabel: 'Suivant',
                                        prevLabel: 'Précédent',
                                        allLabel: 'Toutes'
                                    }"
                        :sort-options="{
                                        enabled: true,
                                        multipleColumns: true,
                                        initialSortBy: {field: 'Name', type: 'asc'}
                                      }"
                        compactMode>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'RfaPaymentStatus'" :class="'rfa-status-circle-' + props.row.RfaPaymentStatus">
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
  import Chart from "chart.js";
  import { uniq } from "@/utils"
  import { getFrsRfaState } from "@/utils/frs";

  export default {
    name: "RFA",
    props: ["periodId"],
    data() {
      return {
        chart: null,
        activeLegend: [true, true, true, true],
        rfaDatas: []
      };
    },
    mounted() {
      this.showChart();
      this.initData();
    },
    watch: {
      $route() {
        this.showChart();
      },
      periodId() {
        this.initData();
      },
      rfaDatas() {
        this.showChart();
      }
    },
    methods: {
      initData() {
        if (this.periodId == -1) return;

        getFrsRfaState(this.periodId).then(res => {
          this.rfaDatas = res.sort((a, b) => a.Name < b.Name ? -1 : 1);
        })
      },
      toggleActiveLegend(index) {
        this.activeLegend = [...this.activeLegend.slice(0, index), !this.activeLegend[index], ...this.activeLegend.slice(index + 1)]
      },
      showChart() {
        const canvas = document.getElementById("rfa-chart");
        if (this.chart) this.chart.destroy();
        const data = this.rfaDatas.reduce((acc, row) => {
          acc[row.RfaPaymentStatus - 1] += 1;
          return acc;
        }, [0, 0, 0, 0])

        this.chart = new Chart(canvas, {
          type: 'doughnut',
          data: {
            labels: ['A faire', 'Facturés', 'Payés', 'Versés'],
            datasets: [
              {
                data,
                backgroundColor: ['#D32F2F', '#FFC107', '#388E3C', '#50E3C2'],
              },
            ],
          },
          options: {
            legend: {
              display: false
            },
            cutoutPercentage: 80,
            responsive: true,
            maintainAspectRatio: false,
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  return " " + data.labels[tooltipItem.index] + " : " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                }
              }
            },
            animation: {
              duration: 230
            }
          }
        });
      },
      formatNbPercent(n) {
        return n.toLocaleString("fr-FR", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },
    },
    computed: {
      rows() {
        return this.rfaDatas.filter(r => this.activeLegend[r.RfaPaymentStatus - 1])
      },
      columns() {
        //const uniqBoards = uniq(this.displayCards.map(c => c.boardName));
        const uniqFamilies = uniq(this.rfaDatas.map(r => r.Family)).sort();
        const uniqSubFamilies = uniq(this.rfaDatas.map(r => r.SubFamily)).sort();

        return [
          { label: "Code Intranet", field: "CodeIntra", filterOptions: { enabled: true, } },
          { label: "Code Compta", field: "CodeCompta", filterOptions: { enabled: true, } },
          { label: "Fournisseur", field: "Name", filterOptions: { enabled: true } },
          {
            label: "Famille", field: "Family", filterOptions: {
              enabled: true,
              placeholder: "Toutes",
              filterDropdownItems: uniqFamilies,
            //  filterFn: (data, filter) => {
            //    if (data.indexOf(filter) !== -1)
            //      return true;
            //    return false;
            //  }
            }
          },
          {
            label: "Sous Famille", field: "SubFamily", filterOptions: {
              enabled: true,
              placeholder: "Toutes",
              filterDropdownItems: uniqSubFamilies,
            }
          },
          { label: "Evolution tx", field: "TxRfaEvolution", formatFn: this.formatNbPercent, sortFn: (a, b) => a - b },
          { label: "Statut", field: "RfaPaymentStatus", tdClass: "rfa-status-container" },
        ]
      }
    }
  }
</script>

<style scoped>
  .rfa-container {
    display: grid;
    grid-template-columns: 340px 1fr;
    column-gap: 24px;
  }

  .white-box {
    padding: 12px;
  }

  .summary h2,
  .details h2 {
    font-size: 20px;
    border-left: 3px solid #A7C13C;
    padding-left: 4px;
  }

  .summary .chart {
    position: relative;
  }

  .summary .chart .total {
    position: absolute;
    top: 50%;
    left: 50%;
    line-height: 1;
    transform: translate(-50%, -50%);
    font-size: 64px;
    font-weight: bold;
  }

  .details .legend {
    display: flex;
    column-gap: 12px;
    margin: 24px 0;
  }

  .details .legend > div {
    padding: 8px 18px;
    color: white;
    background-color: #CCC;
    transition: all ease 230ms;
    border-radius: 6px;
  }

    .details .legend > div:hover {
      cursor: pointer;
      transform: scale(1.05);
    }

    .details .legend > div.active:nth-child(1) {
      background-color: #D32F2F;
    }

    .details .legend > div.active:nth-child(2) {
      background-color: #FFC107;
    }

    .details .legend > div.active:nth-child(3) {
      background-color: #388E3C;
    }

    .details .legend > div.active:nth-child(4) {
      background-color: #50E3C2;
    }
</style>

<style>
  .rfa-status-circle-1,
  .rfa-status-circle-2,
  .rfa-status-circle-3,
  .rfa-status-circle-4
  {
      display: block;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin: auto;
  }

  .rfa-status-circle-1.inline,
  .rfa-status-circle-2.inline,
  .rfa-status-circle-3.inline,
  .rfa-status-circle-4.inline
  {
      display: inline-block;
      margin: 0;
      margin-right: 12px;
      margin-bottom: 6px;
      margin-top: 6px;
  }

  .rfa-status-circle-1 {
      background-color: #D32F2F;
  }

  .rfa-status-circle-2 {
      background-color: #FFC107;
  }

  .rfa-status-circle-3 {
      background-color: #388E3C;
  }

  .rfa-status-circle-4 {
      background-color: #50E3C2;
  }
  .rfa-status-container {
      text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Achat/DashboardCdm/RFA.vue